/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ppi_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is dot pitch?`)
};

const es_ppi_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es el paso de píxel?`)
};

const de_ppi_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist der Pixelabstand?`)
};

const nl_ppi_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is dot pitch?`)
};

const fr_ppi_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce que le pas de masque ?`)
};

const it_ppi_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è il dot pitch?`)
};

const pt_br2_ppi_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é dot pitch?`)
};

const pt_ppi_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é o pitch de píxel?`)
};

const ja_ppi_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドットピッチとは何ですか?`)
};

const zh_ppi_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是点距？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ppi_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ppi_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ppi_faq_q3", locale)
	if (locale === "en") return en_ppi_faq_q3(inputs)
	if (locale === "es") return es_ppi_faq_q3(inputs)
	if (locale === "de") return de_ppi_faq_q3(inputs)
	if (locale === "nl") return nl_ppi_faq_q3(inputs)
	if (locale === "fr") return fr_ppi_faq_q3(inputs)
	if (locale === "it") return it_ppi_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_ppi_faq_q3(inputs)
	if (locale === "pt") return pt_ppi_faq_q3(inputs)
	if (locale === "ja") return ja_ppi_faq_q3(inputs)
	return zh_ppi_faq_q3(inputs)
};